/**
 * @generated SignedSource<<5e812ee897cf8e3edeec29f86e22854e>>
 * @relayHash 0ac4094abdec605d71743ec509854810
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a50dd927fc6677a1e65f676e91a9273c2b09b1c4278247fa45eaa3065e6778de

import type { ConcreteRequest, Query } from 'relay-runtime';
export type columnsSettingsPageNewQuery$variables = {
  boardId: string;
  cloudId: string;
};
export type columnsSettingsPageNewQuery$data = {
  readonly boardScope: {
    readonly columnsConfig: {
      readonly columns: ReadonlyArray<{
        readonly columnStatus: ReadonlyArray<{
          readonly status: {
            readonly category: string;
            readonly id: string;
            readonly isPresentInWorkflow: boolean;
            readonly isResolutionDone: boolean | null | undefined;
            readonly issueMetaData: {
              readonly issueCount: number;
            };
            readonly name: string;
          };
        }>;
        readonly id: string;
        readonly isKanPlanColumn: boolean;
        readonly maxCardCount: number | null | undefined;
        readonly minCardCount: number | null | undefined;
        readonly name: string;
      } | null | undefined>;
      readonly constraintsStatisticsField: {
        readonly availableConstraints: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        } | null | undefined>;
        readonly currentId: string;
      };
      readonly isSprintSupportEnabled: boolean;
      readonly showEpicAsPanel: boolean;
      readonly unmappedStatuses: ReadonlyArray<{
        readonly category: string;
        readonly id: string;
        readonly isPresentInWorkflow: boolean;
        readonly isResolutionDone: boolean | null | undefined;
        readonly issueMetaData: {
          readonly issueCount: number;
        };
        readonly name: string;
      } | null | undefined>;
      readonly workflow: {
        readonly canSimplifyWorkflow: boolean | null | undefined;
        readonly isProjectAdminOfSimplifiedWorkflow: boolean | null | undefined;
        readonly userCanSimplifyWorkflow: boolean | null | undefined;
        readonly usingSimplifiedWorkflow: boolean;
      };
    };
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
    readonly id: string;
  };
  readonly jira: {
    readonly issueHierarchyConfig: {
      readonly data: ReadonlyArray<{
        readonly hierarchyLevel: {
          readonly level: number;
          readonly name: string;
        };
      }>;
    };
  };
};
export type columnsSettingsPageNewQuery = {
  response: columnsSettingsPageNewQuery$data;
  variables: columnsSettingsPageNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "level"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Literal",
    "name": "isCMP",
    "value": true
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "permissions"
},
v7 = {
  "kind": "ScalarField",
  "name": "showEpicAsPanel"
},
v8 = {
  "kind": "ScalarField",
  "name": "isSprintSupportEnabled"
},
v9 = {
  "kind": "ScalarField",
  "name": "isKanPlanColumn"
},
v10 = {
  "kind": "ScalarField",
  "name": "maxCardCount"
},
v11 = {
  "kind": "ScalarField",
  "name": "minCardCount"
},
v12 = {
  "kind": "ScalarField",
  "name": "category"
},
v13 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v14 = {
  "kind": "ScalarField",
  "name": "isPresentInWorkflow"
},
v15 = {
  "kind": "ScalarField",
  "name": "isResolutionDone"
},
v16 = {
  "kind": "ScalarField",
  "name": "usingSimplifiedWorkflow"
},
v17 = {
  "kind": "ScalarField",
  "name": "isProjectAdminOfSimplifiedWorkflow"
},
v18 = {
  "kind": "ScalarField",
  "name": "canSimplifyWorkflow"
},
v19 = {
  "kind": "ScalarField",
  "name": "userCanSimplifyWorkflow"
},
v20 = {
  "kind": "ScalarField",
  "name": "currentId"
},
v21 = [
  (v5/*: any*/),
  (v3/*: any*/),
  (v12/*: any*/),
  {
    "concreteType": "JswCardStatusIssueMetaData",
    "kind": "LinkedField",
    "name": "issueMetaData",
    "plural": false,
    "selections": [
      (v13/*: any*/)
    ]
  },
  (v14/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "columnsSettingsPageNewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraIssueHierarchyConfigurationQuery",
                "kind": "LinkedField",
                "name": "issueHierarchyConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraIssueHierarchyConfigData",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueTypeHierarchyLevel",
                            "kind": "LinkedField",
                            "name": "hierarchyLevel",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v2/*: any*/),
                                "action": "THROW",
                                "path": "jira.issueHierarchyConfig.data.hierarchyLevel.level"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v3/*: any*/),
                                "action": "THROW",
                                "path": "jira.issueHierarchyConfig.data.hierarchyLevel.name"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.issueHierarchyConfig.data.hierarchyLevel"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.issueHierarchyConfig.data"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.issueHierarchyConfig"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v4/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v5/*: any*/),
              "action": "THROW",
              "path": "boardScope.id"
            },
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v6/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.currentUser.permissions"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.currentUser"
            },
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "ColumnsConfigPage",
                "kind": "LinkedField",
                "name": "columnsConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v7/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.showEpicAsPanel"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v8/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.isSprintSupportEnabled"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "ColumnV2",
                      "kind": "LinkedField",
                      "name": "columns",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v5/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.columns.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.columns.isKanPlanColumn"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.columns.name"
                        },
                        (v10/*: any*/),
                        (v11/*: any*/),
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "ColumnStatusV2",
                            "kind": "LinkedField",
                            "name": "columnStatus",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "StatusV2",
                                  "kind": "LinkedField",
                                  "name": "status",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v5/*: any*/),
                                      "action": "THROW",
                                      "path": "boardScope.columnsConfig.columns.columnStatus.status.id"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v3/*: any*/),
                                      "action": "THROW",
                                      "path": "boardScope.columnsConfig.columns.columnStatus.status.name"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v12/*: any*/),
                                      "action": "THROW",
                                      "path": "boardScope.columnsConfig.columns.columnStatus.status.category"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "JswCardStatusIssueMetaData",
                                        "kind": "LinkedField",
                                        "name": "issueMetaData",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v13/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.columnsConfig.columns.columnStatus.status.issueMetaData.issueCount"
                                          }
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "boardScope.columnsConfig.columns.columnStatus.status.issueMetaData"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v14/*: any*/),
                                      "action": "THROW",
                                      "path": "boardScope.columnsConfig.columns.columnStatus.status.isPresentInWorkflow"
                                    },
                                    (v15/*: any*/)
                                  ]
                                },
                                "action": "THROW",
                                "path": "boardScope.columnsConfig.columns.columnStatus.status"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.columns.columnStatus"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.columns"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "StatusV2",
                      "kind": "LinkedField",
                      "name": "unmappedStatuses",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v5/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.unmappedStatuses.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.unmappedStatuses.name"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.unmappedStatuses.category"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JswCardStatusIssueMetaData",
                            "kind": "LinkedField",
                            "name": "issueMetaData",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v13/*: any*/),
                                "action": "THROW",
                                "path": "boardScope.columnsConfig.unmappedStatuses.issueMetaData.issueCount"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.unmappedStatuses.issueMetaData"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v14/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.unmappedStatuses.isPresentInWorkflow"
                        },
                        (v15/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.unmappedStatuses"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "ColumnWorkflowConfig",
                      "kind": "LinkedField",
                      "name": "workflow",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v16/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.workflow.usingSimplifiedWorkflow"
                        },
                        (v17/*: any*/),
                        (v18/*: any*/),
                        (v19/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.workflow"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "ColumnConstraintStatisticConfig",
                      "kind": "LinkedField",
                      "name": "constraintsStatisticsField",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v20/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.constraintsStatisticsField.currentId"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "AvailableColumnConstraintStatistics",
                            "kind": "LinkedField",
                            "name": "availableConstraints",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v5/*: any*/),
                                "action": "THROW",
                                "path": "boardScope.columnsConfig.constraintsStatisticsField.availableConstraints.id"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v3/*: any*/),
                                "action": "THROW",
                                "path": "boardScope.columnsConfig.constraintsStatisticsField.availableConstraints.name"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "boardScope.columnsConfig.constraintsStatisticsField.availableConstraints"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "boardScope.columnsConfig.constraintsStatisticsField"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.columnsConfig"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "columnsSettingsPageNewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueHierarchyConfigurationQuery",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeHierarchyLevel",
                    "kind": "LinkedField",
                    "name": "hierarchyLevel",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "concreteType": "CurrentUser",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          },
          {
            "concreteType": "ColumnsConfigPage",
            "kind": "LinkedField",
            "name": "columnsConfig",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "ColumnV2",
                "kind": "LinkedField",
                "name": "columns",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/),
                  (v3/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "ColumnStatusV2",
                    "kind": "LinkedField",
                    "name": "columnStatus",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "StatusV2",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "StatusV2",
                "kind": "LinkedField",
                "name": "unmappedStatuses",
                "plural": true,
                "selections": (v21/*: any*/)
              },
              {
                "concreteType": "ColumnWorkflowConfig",
                "kind": "LinkedField",
                "name": "workflow",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "concreteType": "ColumnConstraintStatisticConfig",
                "kind": "LinkedField",
                "name": "constraintsStatisticsField",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "concreteType": "AvailableColumnConstraintStatistics",
                    "kind": "LinkedField",
                    "name": "availableConstraints",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a50dd927fc6677a1e65f676e91a9273c2b09b1c4278247fa45eaa3065e6778de",
    "metadata": {},
    "name": "columnsSettingsPageNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2daca7bc425d685fcbf9ebe65fc4eaa2";

export default node;
